export function IconLogo() {
    return (
        <div className="logoPreview"></div>
    )
}